import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import {
  PlumaBadge as PlumaBadgeCss,
  PlumaButton as PlumaButtonCss,
} from '@customerio/pluma-components/css/components';
import { layerHover, layerPressed, shiftHoverStroke } from '@customerio/pluma-components/css/utils';

/** The Credits Lifecycle prototype's Flex tag tint, the same teal ui's segment counter uses below the cap. */
export const flexTag = style(
  {
    vars: {
      [PlumaButtonCss.vars.backgroundColor]: themeVars.palette['teal-25'],
      [PlumaButtonCss.vars.backgroundColorHover]: layerHover(
        PlumaButtonCss.resolvedVars.backgroundColor,
        themeVars.palette['teal-800'],
      ),
      [PlumaButtonCss.vars.backgroundColorActive]: layerPressed(
        PlumaButtonCss.resolvedVars.backgroundColor,
        themeVars.palette['teal-800'],
      ),
      [PlumaButtonCss.vars.borderColor]: themeVars.palette['teal-100'],
      [PlumaButtonCss.vars.borderColorHover]: shiftHoverStroke(themeVars.palette['teal-200']),
      [PlumaButtonCss.vars.borderColorActive]: shiftHoverStroke(themeVars.palette['teal-200']),
      [PlumaButtonCss.vars.textColor]: themeVars.palette['teal-800'],
      [PlumaButtonCss.vars.textColorHover]: shiftHoverStroke(themeVars.palette['teal-800']),
      [PlumaButtonCss.vars.textColorActive]: shiftHoverStroke(themeVars.palette['teal-800']),
      [PlumaButtonCss.vars.textColorFocus]: themeVars.palette['teal-800'],
    },
    selectors: {
      // The pale tint would wash out the Flex mark's light dark-mode body, so the tag turns dark too.
      '[data-pluma-color-scheme="dark"] &': {
        vars: {
          [PlumaButtonCss.vars.backgroundColor]: themeVars.palette['teal-950'],
          [PlumaButtonCss.vars.backgroundColorHover]: layerHover(
            PlumaButtonCss.resolvedVars.backgroundColor,
            themeVars.palette['teal-25'],
          ),
          [PlumaButtonCss.vars.backgroundColorActive]: layerPressed(
            PlumaButtonCss.resolvedVars.backgroundColor,
            themeVars.palette['teal-25'],
          ),
          [PlumaButtonCss.vars.borderColor]: themeVars.palette['teal-800'],
          [PlumaButtonCss.vars.borderColorHover]: shiftHoverStroke(themeVars.palette['teal-700']),
          [PlumaButtonCss.vars.borderColorActive]: shiftHoverStroke(themeVars.palette['teal-700']),
          [PlumaButtonCss.vars.textColor]: themeVars.palette['teal-25'],
          [PlumaButtonCss.vars.textColorHover]: themeVars.palette['teal-25'],
          [PlumaButtonCss.vars.textColorActive]: themeVars.palette['teal-25'],
          [PlumaButtonCss.vars.textColorFocus]: themeVars.palette['teal-25'],
        },
      },
    },
  },
  'segments-addon-button-flex-tag',
);

/** The Flex tag tint on a read-only Pluma Badge, for a menu entry that already opens the add-on. */
export const flexBadge = style(
  {
    vars: {
      [PlumaBadgeCss.vars.badgeBackgroundColor]: themeVars.palette['teal-25'],
      [PlumaBadgeCss.vars.badgeBorderColor]: themeVars.palette['teal-100'],
      [PlumaBadgeCss.vars.badgeTextColor]: themeVars.palette['teal-800'],
    },
    verticalAlign: 'text-top',
    selectors: {
      // Dark like the Flex tag button, for the same reason.
      '[data-pluma-color-scheme="dark"] &': {
        vars: {
          [PlumaBadgeCss.vars.badgeBackgroundColor]: themeVars.palette['teal-950'],
          [PlumaBadgeCss.vars.badgeBorderColor]: themeVars.palette['teal-800'],
          [PlumaBadgeCss.vars.badgeTextColor]: themeVars.palette['teal-25'],
        },
      },
    },
  },
  'segments-addon-flex-badge',
);
